import { Spin } from 'antd';

import './DataLoadingSpinner.scss';

export const DataLoadingSpinner = () => {
  return (
    <div className="data-loading-spinner">
      <Spin />
    </div>
  );
};
